import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { formatDate } from '../utils/dateUtils';

const { FiChevronLeft, FiChevronRight } = FiIcons;

function HolidayTimeline({ holidays, currentHolidayId }) {
  const [position, setPosition] = useState(0);

  const highlightedIndex = holidays.findIndex(
    (holiday) => holiday.id === currentHolidayId
  );

  useEffect(() => {
    setPosition(highlightedIndex > -1 ? highlightedIndex : 0);
  }, [currentHolidayId, highlightedIndex]);

  const move = (direction) => {
    if (!holidays.length) return;

    setPosition((current) => {
      const next = current + direction;

      if (next < 0) return holidays.length - 1;
      if (next >= holidays.length) return 0;

      return next;
    });
  };

  return (
    <section className="timeline-section" aria-labelledby="timeline-title">
      <div className="section-heading">
        <div>
          <p className="section-kicker">Bayern</p>
          <h2 id="timeline-title">Deine nächsten Ferienmomente</h2>
        </div>
        <p>Mit Pfeilen durch die Ferien blättern</p>
      </div>

      <div className="timeline-carousel" aria-label="Ferienübersicht">
        <button
          className="humor-arrow timeline-arrow"
          type="button"
          onClick={() => move(-1)}
          aria-label="Vorherige Ferien anzeigen"
          disabled={holidays.length < 2}
        >
          <SafeIcon icon={FiChevronLeft} aria-hidden="true" />
        </button>

        <div className="timeline-viewport">
          <div
            className="timeline"
            style={{ transform: `translateX(-${position * 100}%)` }}
          >
            {holidays.map((holiday, index) => {
              const highlighted = holiday.id === currentHolidayId
                || (!currentHolidayId && index === 0);

              return (
                <article
                  className={`timeline-item ${highlighted ? 'active' : ''}`}
                  key={holiday.id}
                >
                  <span className="timeline-dot" aria-hidden="true" />
                  <p className="timeline-index">
                    {highlighted ? 'Als Nächstes' : `Danach ${index + 1}`}
                  </p>
                  <h3>{holiday.name}</h3>
                  <p>
                    {formatDate(holiday.startDate, { year: undefined })}
                    {' – '}
                    {formatDate(holiday.endDate)}
                  </p>
                </article>
              );
            })}
          </div>
        </div>

        <button
          className="humor-arrow timeline-arrow"
          type="button"
          onClick={() => move(1)}
          aria-label="Nächste Ferien anzeigen"
          disabled={holidays.length < 2}
        >
          <SafeIcon icon={FiChevronRight} aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}

export default HolidayTimeline;